const merge = require('lodash.merge')

function mergePalettes(basePalette, subPalette) {
  return merge(basePalette, subPalette)
}

module.exports.mergePalettes = mergePalettes
